
import { useState } from 'react';

interface InventoryBatch {
  id: string;
  variety: string;
  batchNo: string;
  quantity: number;
  unit: string;
  storageLocation: string;
  warehouseNo: string;
  inDate: string;
  source: string;
  supplier: string;
  grade: string;
  moisture: string;
  impurity: string;
  incomplete: string;
  qualityStatus: '合格' | '临界' | '不合格';
  storageDays: number;
  remark: string;
}

const inventoryBatches: InventoryBatch[] = [
  {
    id: '1', variety: '小麦', batchNo: 'XM-2026-0215-001', quantity: 1200, unit: '吨',
    storageLocation: '1号平房仓-A区', warehouseNo: 'W-01-A', inDate: '2026-02-15',
    source: '本地收购', supplier: '张三农场', grade: '一等',
    moisture: '12.3%', impurity: '0.8%', incomplete: '4.2%',
    qualityStatus: '合格', storageDays: 1, remark: '优质小麦',
  },
  {
    id: '2', variety: '小麦', batchNo: 'XM-2026-0212-003', quantity: 1800, unit: '吨',
    storageLocation: '1号平房仓-B区', warehouseNo: 'W-01-B', inDate: '2026-02-12',
    source: '本地收购', supplier: '吴九粮站', grade: '一等',
    moisture: '12.1%', impurity: '0.7%', incomplete: '3.9%',
    qualityStatus: '合格', storageDays: 4, remark: '批量收购',
  },
  {
    id: '3', variety: '小麦', batchNo: 'XM-2026-0205-002', quantity: 2680, unit: '吨',
    storageLocation: '2号立筒仓-1号筒', warehouseNo: 'W-02-T1', inDate: '2026-02-05',
    source: '跨区调入', supplier: '河南粮食集团', grade: '二等',
    moisture: '13.0%', impurity: '0.95%', incomplete: '5.1%',
    qualityStatus: '临界', storageDays: 11, remark: '水分偏高，注意通风',
  },
  {
    id: '4', variety: '玉米', batchNo: 'YM-2026-0210-001', quantity: 2000, unit: '吨',
    storageLocation: '3号平房仓-A区', warehouseNo: 'W-03-A', inDate: '2026-02-10',
    source: '本地收购', supplier: '楚十三合作社', grade: '一等',
    moisture: '13.2%', impurity: '0.9%', incomplete: '4.5%',
    qualityStatus: '合格', storageDays: 6, remark: '',
  },
  {
    id: '5', variety: '玉米', batchNo: 'YM-2026-0201-002', quantity: 1500, unit: '吨',
    storageLocation: '3号平房仓-B区', warehouseNo: 'W-03-B', inDate: '2026-02-01',
    source: '本地收购', supplier: '李四合作社', grade: '二等',
    moisture: '13.8%', impurity: '1.1%', incomplete: '5.8%',
    qualityStatus: '临界', storageDays: 15, remark: '杂质率偏高',
  },
  {
    id: '6', variety: '玉米', batchNo: 'YM-2026-0120-001', quantity: 700, unit: '吨',
    storageLocation: '2号立筒仓-2号筒', warehouseNo: 'W-02-T2', inDate: '2026-01-20',
    source: '跨区调入', supplier: '山东粮油公司', grade: '一等',
    moisture: '12.5%', impurity: '0.75%', incomplete: '4.0%',
    qualityStatus: '合格', storageDays: 27, remark: '',
  },
  {
    id: '7', variety: '大米', batchNo: 'DM-2026-0214-001', quantity: 1500, unit: '吨',
    storageLocation: '4号低温仓-A区', warehouseNo: 'W-04-A', inDate: '2026-02-14',
    source: '本地收购', supplier: '王五合作社', grade: '一等',
    moisture: '14.0%', impurity: '0.3%', incomplete: '3.0%',
    qualityStatus: '合格', storageDays: 2, remark: '优质稻谷',
  },
  {
    id: '8', variety: '大米', batchNo: 'DM-2026-0130-002', quantity: 2300, unit: '吨',
    storageLocation: '4号低温仓-B区', warehouseNo: 'W-04-B', inDate: '2026-01-30',
    source: '本地收购', supplier: '南方粮食公司', grade: '一等',
    moisture: '13.8%', impurity: '0.35%', incomplete: '3.2%',
    qualityStatus: '合格', storageDays: 17, remark: '',
  },
  {
    id: '9', variety: '大豆', batchNo: 'DD-2026-0213-001', quantity: 1200, unit: '吨',
    storageLocation: '5号平房仓-A区', warehouseNo: 'W-05-A', inDate: '2026-02-13',
    source: '本地收购', supplier: '孙七农业', grade: '二等',
    moisture: '11.5%', impurity: '1.2%', incomplete: '5.5%',
    qualityStatus: '临界', storageDays: 3, remark: '不完善粒偏高',
  },
  {
    id: '10', variety: '大豆', batchNo: 'DD-2026-0125-002', quantity: 800, unit: '吨',
    storageLocation: '5号平房仓-B区', warehouseNo: 'W-05-B', inDate: '2026-01-25',
    source: '跨区调入', supplier: '黑龙江大豆集团', grade: '一等',
    moisture: '11.0%', impurity: '0.6%', incomplete: '3.8%',
    qualityStatus: '合格', storageDays: 22, remark: '',
  },
  {
    id: '11', variety: '高粱', batchNo: 'GL-2026-0208-001', quantity: 600, unit: '吨',
    storageLocation: '6号平房仓', warehouseNo: 'W-06', inDate: '2026-02-08',
    source: '本地收购', supplier: '冯十一农场', grade: '一等',
    moisture: '12.0%', impurity: '0.5%', incomplete: '3.5%',
    qualityStatus: '合格', storageDays: 8, remark: '',
  },
];

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function InventoryDetailModal({ open, onClose }: Props) {
  const [filterVariety, setFilterVariety] = useState('全部');
  const [filterQuality, setFilterQuality] = useState('全部');
  const [sortBy, setSortBy] = useState<'inDate' | 'quantity' | 'storageDays'>('inDate');

  if (!open) return null;

  const varieties = ['全部', ...Array.from(new Set(inventoryBatches.map(b => b.variety)))];
  const qualityOptions = ['全部', '合格', '临界', '不合格'];

  const filtered = inventoryBatches
    .filter(b => filterVariety === '全部' || b.variety === filterVariety)
    .filter(b => filterQuality === '全部' || b.qualityStatus === filterQuality)
    .sort((a, b) => {
      if (sortBy === 'inDate') return new Date(b.inDate).getTime() - new Date(a.inDate).getTime();
      if (sortBy === 'quantity') return b.quantity - a.quantity;
      return b.storageDays - a.storageDays;
    });

  // 汇总
  const summary = {
    totalQuantity: filtered.reduce((s, b) => s + b.quantity, 0),
    totalBatches: filtered.length,
    passedBatches: filtered.filter(b => b.qualityStatus === '合格').length,
    criticalBatches: filtered.filter(b => b.qualityStatus === '临界').length,
    failedBatches: filtered.filter(b => b.qualityStatus === '不合格').length,
    locations: new Set(filtered.map(b => b.warehouseNo)).size,
  };

  const getQualityBadge = (status: string) => {
    switch (status) {
      case '合格': return 'bg-emerald-100 text-emerald-700';
      case '临界': return 'bg-amber-100 text-amber-700';
      case '不合格': return 'bg-rose-100 text-rose-700';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  const getGradeBadge = (grade: string) => {
    switch (grade) {
      case '一等': return 'bg-[#0c7362]/10 text-[#0c7362]';
      case '二等': return 'bg-amber-50 text-amber-600';
      case '三等': return 'bg-orange-50 text-orange-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm" onClick={onClose}>
      <div
        className="bg-white rounded-2xl shadow-2xl w-[95%] max-w-[1200px] max-h-[90vh] flex flex-col overflow-hidden"
        onClick={e => e.stopPropagation()}
      >
        {/* 头部 */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100 bg-gradient-to-r from-[#0c7362]/5 to-transparent">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-[#0c7362]/10 rounded-xl flex items-center justify-center">
              <i className="ri-database-2-line text-xl text-[#0c7362]"></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">库存批次明细</h2>
              <p className="text-xs text-gray-500">查看各品种库存的批次、存放地点、质量指标及来源信息</p>
            </div>
          </div>
          <button onClick={onClose} className="w-9 h-9 flex items-center justify-center rounded-xl hover:bg-gray-100 cursor-pointer">
            <i className="ri-close-line text-xl text-gray-500"></i>
          </button>
        </div>

        {/* 汇总指标 */}
        <div className="px-6 pt-4 pb-2">
          <div className="grid grid-cols-6 gap-3">
            <div className="bg-[#0c7362]/5 rounded-xl px-3 py-2.5 text-center">
              <div className="text-[11px] text-gray-500">总库存量</div>
              <div className="text-lg font-bold text-[#0c7362]">{summary.totalQuantity.toLocaleString()}<span className="text-xs font-normal text-gray-400 ml-0.5">吨</span></div>
            </div>
            <div className="bg-gray-50 rounded-xl px-3 py-2.5 text-center">
              <div className="text-[11px] text-gray-500">批次数</div>
              <div className="text-lg font-bold text-gray-700">{summary.totalBatches}<span className="text-xs font-normal text-gray-400 ml-0.5">批</span></div>
            </div>
            <div className="bg-emerald-50 rounded-xl px-3 py-2.5 text-center">
              <div className="text-[11px] text-gray-500">合格批次</div>
              <div className="text-lg font-bold text-emerald-600">{summary.passedBatches}<span className="text-xs font-normal text-gray-400 ml-0.5">批</span></div>
            </div>
            <div className="bg-amber-50 rounded-xl px-3 py-2.5 text-center">
              <div className="text-[11px] text-gray-500">临界批次</div>
              <div className="text-lg font-bold text-amber-600">{summary.criticalBatches}<span className="text-xs font-normal text-gray-400 ml-0.5">批</span></div>
            </div>
            <div className="bg-rose-50 rounded-xl px-3 py-2.5 text-center">
              <div className="text-[11px] text-gray-500">不合格批次</div>
              <div className="text-lg font-bold text-rose-500">{summary.failedBatches}<span className="text-xs font-normal text-gray-400 ml-0.5">批</span></div>
            </div>
            <div className="bg-gray-50 rounded-xl px-3 py-2.5 text-center">
              <div className="text-[11px] text-gray-500">存放仓位</div>
              <div className="text-lg font-bold text-gray-700">{summary.locations}<span className="text-xs font-normal text-gray-400 ml-0.5">个</span></div>
            </div>
          </div>
        </div>

        {/* 筛选栏 */}
        <div className="px-6 py-3 flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <span className="text-xs text-gray-500">品种：</span>
            <div className="flex items-center space-x-1 bg-gray-100 rounded-lg p-0.5">
              {varieties.map(v => (
                <button
                  key={v}
                  onClick={() => setFilterVariety(v)}
                  className={`px-2.5 py-1 text-xs rounded-md whitespace-nowrap cursor-pointer transition-all ${
                    filterVariety === v ? 'bg-white text-gray-800 shadow-sm font-medium' : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {v}
                </button>
              ))}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <span className="text-xs text-gray-500">质量：</span>
            <div className="flex items-center space-x-1 bg-gray-100 rounded-lg p-0.5">
              {qualityOptions.map(q => (
                <button
                  key={q}
                  onClick={() => setFilterQuality(q)}
                  className={`px-2.5 py-1 text-xs rounded-md whitespace-nowrap cursor-pointer transition-all ${
                    filterQuality === q ? 'bg-white text-gray-800 shadow-sm font-medium' : 'text-gray-500 hover:text-gray-700'
                  }`}
                >
                  {q}
                </button>
              ))}
            </div>
          </div>
          <div className="flex items-center space-x-2 ml-auto">
            <span className="text-xs text-gray-500">排序：</span>
            <select
              value={sortBy}
              onChange={e => setSortBy(e.target.value as typeof sortBy)}
              className="text-xs border border-gray-200 rounded-lg px-2.5 py-1.5 bg-white text-gray-700 cursor-pointer focus:outline-none focus:ring-1 focus:ring-[#0c7362]/30"
            >
              <option value="inDate">入库日期</option>
              <option value="quantity">库存数量</option>
              <option value="storageDays">存储天数</option>
            </select>
          </div>
        </div>

        {/* 表格 */}
        <div className="flex-1 overflow-auto px-6 pb-4">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-gray-50 sticky top-0 z-10">
                <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-600 rounded-l-lg">批次号</th>
                <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-600">品种</th>
                <th className="text-right px-3 py-2.5 text-xs font-semibold text-gray-600">数量(吨)</th>
                <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-600">存放地点</th>
                <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-600">仓位号</th>
                <th className="text-center px-3 py-2.5 text-xs font-semibold text-gray-600">等级</th>
                <th className="text-center px-3 py-2.5 text-xs font-semibold text-gray-600">水分</th>
                <th className="text-center px-3 py-2.5 text-xs font-semibold text-gray-600">杂质率</th>
                <th className="text-center px-3 py-2.5 text-xs font-semibold text-gray-600">不完善粒</th>
                <th className="text-center px-3 py-2.5 text-xs font-semibold text-gray-600">质量</th>
                <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-600">来源</th>
                <th className="text-left px-3 py-2.5 text-xs font-semibold text-gray-600">供应商</th>
                <th className="text-center px-3 py-2.5 text-xs font-semibold text-gray-600">入库日期</th>
                <th className="text-center px-3 py-2.5 text-xs font-semibold text-gray-600 rounded-r-lg">存储天数</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((batch, idx) => (
                <tr key={batch.id} className={`border-b border-gray-50 hover:bg-[#0c7362]/[0.02] transition-colors ${idx % 2 === 0 ? '' : 'bg-gray-50/50'}`}>
                  <td className="px-3 py-3 text-xs font-mono text-gray-700 font-medium">{batch.batchNo}</td>
                  <td className="px-3 py-3">
                    <span className="text-xs font-medium text-gray-800">{batch.variety}</span>
                  </td>
                  <td className="px-3 py-3 text-right text-xs font-semibold text-gray-800">{batch.quantity.toLocaleString()}</td>
                  <td className="px-3 py-3 text-xs text-gray-600">{batch.storageLocation}</td>
                  <td className="px-3 py-3 text-xs font-mono text-gray-500">{batch.warehouseNo}</td>
                  <td className="px-3 py-3 text-center">
                    <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${getGradeBadge(batch.grade)}`}>{batch.grade}</span>
                  </td>
                  <td className="px-3 py-3 text-center text-xs text-gray-600">{batch.moisture}</td>
                  <td className="px-3 py-3 text-center text-xs text-gray-600">{batch.impurity}</td>
                  <td className="px-3 py-3 text-center text-xs text-gray-600">{batch.incomplete}</td>
                  <td className="px-3 py-3 text-center">
                    <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium ${getQualityBadge(batch.qualityStatus)}`}>{batch.qualityStatus}</span>
                  </td>
                  <td className="px-3 py-3 text-xs text-gray-600">{batch.source}</td>
                  <td className="px-3 py-3 text-xs text-gray-700 font-medium">{batch.supplier}</td>
                  <td className="px-3 py-3 text-center text-xs text-gray-600">{batch.inDate}</td>
                  <td className="px-3 py-3 text-center">
                    <span className={`text-xs font-medium ${batch.storageDays > 20 ? 'text-amber-600' : 'text-gray-600'}`}>
                      {batch.storageDays}天
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div className="py-12 text-center text-gray-400">
              <i className="ri-inbox-line text-3xl mb-2 block"></i>
              <p className="text-sm">暂无匹配的库存批次</p>
            </div>
          )}
        </div>

        {/* 底部备注 */}
        <div className="px-6 py-3 border-t border-gray-100 bg-gray-50/50 flex items-center justify-between">
          <div className="text-[11px] text-gray-400">
            <i className="ri-information-line mr-1"></i>
            质量指标参照国家粮食质量标准（GB 1351-2008等），临界表示接近标准上限需关注
          </div>
          <button onClick={onClose} className="px-5 py-2 bg-gray-100 text-gray-600 rounded-xl text-sm font-medium hover:bg-gray-200 whitespace-nowrap cursor-pointer">
            关闭
          </button>
        </div>
      </div>
    </div>
  );
}
